function Tages({ props }) {
	return <div className={` ${props.bg} rounded ring-2 mx-1 px-1 text-green-500`}>{props.body}</div>;
}

export default Tages;
